import contract, { selectors } from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import redirect from '#utilities/js/hotkey/redirect.js'
import forward from './forward/forward'
import remove from './remove/remove.js'
import reply from './reply/reply.js'
import replyAll from './replyAll/replyAll.js'

export default contract({
  [selectors]: {
    'slot[data-name="hotkey-delete"]': array([
      remove
    ]),
    'slot[data-name="hotkey-forward"]': array([
      forward
    ]),
    'slot[data-name="hotkey-next"]': array([
      redirect
    ]),
    'slot[data-name="hotkey-previous"]': array([
      redirect
    ]),
    'slot[data-name="hotkey-new"]': array([
      redirect
    ]),
    'slot[data-name="hotkey-reply"]': array([
      reply
    ]),
    'slot[data-name="hotkey-reply_all"]': array([
      replyAll
    ])
  }
})
